import cls from "classnames";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserWebAccessFormData } from "../types";
// components
import { Button, Form, Input, Select } from "antd";

export const Step4Form: React.FC<{
  data: UserWebAccessFormData;
  visible: boolean;
  loading: boolean;
  onPrev: () => void;
  onNext: (data: UserWebAccessFormData) => void;
  onCancel: () => void;
}> = ({ data, visible, loading, onPrev, onNext, onCancel }) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<UserWebAccessFormData>();

  const [webAccessMode, setWebAccessMode] = useState<number>(
    data.web_access_mode
  );

  const handleWebAccessModeChange = (value: number) => {
    setWebAccessMode(value);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      className={cls(["mt:16", { hidden: !visible }])}
      onFinish={(values) => {
        onNext(values);
      }}
    >
      <Form.Item
        label={t("systems.Extra.mode")}
        colon={false}
        required={false}
        className="flex:1"
        name="web_access_mode"
      >
        <Select onChange={handleWebAccessModeChange}>
          <Select.Option value={0}>
            {t("systems.Extra.whiteList")}
          </Select.Option>
          <Select.Option value={1}>
            {t("systems.Extra.blackList")}
          </Select.Option>
        </Select>
      </Form.Item>

      {webAccessMode === 0 && (
        <div>
          <h3 className="mb:12 t:center">{t("systems.Extra.whiteList")}</h3>

          <Form.Item
            label={t("domains.Tenant.basicFunctions")}
            name="web_white_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>
        </div>
      )}

      {webAccessMode === 1 && (
        <div>
          <h3 className="mb:12 t:center">{t("systems.Extra.blackList")}</h3>

          <Form.Item
            label={t("domains.Tenant.basicFunctions")}
            name="web_black_ips"
            extra={t("systems.Extra.inputEachOnASeparateLineIfMultiple", {
              field: "IP",
            })}
          >
            <Input.TextArea rows={4}></Input.TextArea>
          </Form.Item>
        </div>
      )}

      <Form.Item>
        <div className="flex jc:end gap:8">
          <Button htmlType="button" onClick={onCancel}>
            {t("systems.Action.cancel")}
          </Button>
          <Button htmlType="button" onClick={onPrev}>
            {t("systems.Action.prev")}
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t("systems.Action.submit")}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
